import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { RightPanel } from '@atlassian/jira-navigation-system/src/index.tsx';
import { useCurrentPreviewPanel } from '@atlassian/preview-panels-api';

export const PreviewPanel = () => {
	const panel = useCurrentPreviewPanel();

	if (panel == null) {
		return null;
	}

	const { content: PanelContent, width } = panel;

	return (
		<RightPanel width={width} testId="page-container-v2.common.ui.preview-panel">
			<JSErrorBoundary
				fallback="unmount"
				id="preview-panel-route-components"
				packageName="page-container"
			>
				<PanelContent />
			</JSErrorBoundary>
		</RightPanel>
	);
};
